module.exports = __webpack_public_path__ + "static/media/VRED Render Node.fa11d602.png";